module.exports = __webpack_public_path__ + "static/media/diy_eq_icon.caecb762.svg";